import { UserProfile } from "./user-profile";

export class UserProfileStatus { 
    userProfileNotFound!: boolean;
    verificationFailed!: boolean;
    userProfile!: UserProfile;
 }